import { Report } from './action';

/* --- Reducer and his sub components types --- */
export interface reportingState {
  companiesStatus: CompanyStatus[];
  users: string[];
  filters: ReportsFilters;
  cancelTokenSource;
  isLoading: boolean;
  selectedReport: reportKind | null;
  products: string[];
  data?: Report;
}

interface CompanyStatus {
  color_code: string;
  name: string;
  value: string;
}

interface ReportsFilters {
  PresencePerProductPerCompany: object;
  MerchandisingPerCompany: object;
  EventsPerCompany: object;
  EventsPerUser: object;
  CompanyStatusEvolution: string[];
  PresencePerUsers: string[];
  PresencePerProducts: string[];
  OrderPerProductPerCompany: object;
  PresencePerBrandOrCategoryPerCompany: object;
}

type reportKind = string;

/* -------------- Action's type -------------- */
export type reportingAction =
  | { type: 'SET_SELECTED_REPORT'; value: string; data: Report }
  | { type: 'SET_COMPANIES_STATUS'; value: reportingState['companiesStatus'] }
  | { type: 'SET_FILTERS'; value: reportingState['filters'] }
  | { type: 'SET_CANCEL_TOKEN_SOURCE' }
  | { type: 'SET_IS_LOADING'; value: reportingState['isLoading'] }
  | { type: 'SET_USERS'; value: reportingState['users'] }
  | { type: 'SET_PRODUCTS'; value: reportingState['products'] };

/* ----------------- Reducer ----------------- */
export function initState() {
	const ret: reportingState = {
		companiesStatus: [],
		filters: {
			PresencePerProductPerCompany: {},
			MerchandisingPerCompany: {},
			EventsPerCompany: {},
			EventsPerUser: {},
			CompanyStatusEvolution: [],
			PresencePerUsers: [],
			PresencePerProducts: [],
			OrderPerProductPerCompany: {},
			PresencePerBrandOrCategoryPerCompany: {}
		},
		cancelTokenSource: null,
		isLoading: false,
		selectedReport: null,
		users: [],
		products: []
	};
	return ret;
}

export function reducer(
	state: reportingState,
	action: reportingAction,
	history: any
): reportingState {
	switch (action.type) {
		case 'SET_COMPANIES_STATUS':
			return {
				...state,
				companiesStatus: action.value
			};
		case 'SET_FILTERS':
			return {
				...state,
				filters: action.value
			};
		case 'SET_CANCEL_TOKEN_SOURCE':
			return {
				...state
				// cancelTokenSource: action.value
			};
		case 'SET_IS_LOADING':
			return {
				...state,
				isLoading: action.value
			};
		case 'SET_SELECTED_REPORT':
			localStorage.setItem('report_id_to_view', action.value);
			history.replace({ hash: 'generic' });
			return {
				...state,
				selectedReport: action.value,
				data: action.data
			};
		case 'SET_USERS':
			return {
				...state,
				users: action.value
			};
		case 'SET_PRODUCTS':
			return {
				...state,
				products: action.value
			};
		default:
			return { ...state };
	}
}
